import { render, staticRenderFns } from "./selectSet.vue?vue&type=template&id=04474a58&scoped=true"
import script from "./selectSet.vue?vue&type=script&lang=js"
export * from "./selectSet.vue?vue&type=script&lang=js"
import style0 from "./selectSet.vue?vue&type=style&index=0&id=04474a58&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04474a58",
  null
  
)

export default component.exports